/*
persistedAppData holds "session" data
upload login it grabs
userinfo
  userid, email, user level preferences, etc
lookupdata
  building acl
  states
  energy types
  equipment types
  ...
  anything which could go into a "drop down" where we don't want to make a homerun to the server

If the user hits "reload/f5" , this data sticks around
*/
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { logFilter } from "@logging";
import { talkToServer } from "@helpers/servercomms";

export const saveUserOptions = createAsyncThunk(
  "persistedAppdata/saveUserOptions",
  async (options) => {
    const request = {
      context: {
        topic: "useroptions",
        action: "saveoptions",
        options: options.options,
        useCache: false,
      },
      payload: options.payload,
    };
    const response = await talkToServer(request);
    if (response && response !== undefined) {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const getBookmarksForUser = createAsyncThunk(
  "persistedAppdata/getBookmarksForUser",
  async (options) => {
    const request = {
      context: { topic: "bookmarks", action: "list", options, useCache: false },
      payload: {},
    };
    logFilter("bookmarks", "call to server for bookmarks", request);
    const response = await talkToServer(request);
    logFilter("bookmarks", "back with bookmarks data", response);
    //if (response && (response !== undefined) && response.rc === 'OK') {
    if (response && response !== undefined) {
      logFilter("bookmarks", "back with bookmarks data good?", response);
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const saveOneBookmarkForUser = createAsyncThunk(
  "persistedAppdata/getBookmarksForUser",
  async (options) => {
    logFilter("bookmarks", "saveOneBookmarkForUser", options);
    const request = {
      context: {
        topic: "bookmarks",
        action: "saveOne",
        options: options.options,
        useCache: false,
      },
      payload: options.payload,
    };
    logFilter("bookmarks", "call to server for saveOne bookmark", request);
    const response = await talkToServer(request);
    logFilter("bookmarks", "back with bookmarks data", response);
    //if (response && (response !== undefined) && response.rc === 'OK') {
    if (response && response !== undefined) {
      logFilter("bookmarks", "back with bookmarks data good?", response);
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const deleteOneBookmarkForUser = createAsyncThunk(
  "persistedAppdata/getBookmarksForUser",
  async (options) => {
    logFilter("bookmarks", "deleteOneBookmarkForUser", options);
    const request = {
      context: {
        topic: "bookmarks",
        action: "deleteOne",
        options: options.options,
        useCache: false,
      },
      payload: {},
    };
    logFilter("bookmarks", "call to server for deleteOne bookmark", request);
    const response = await talkToServer(request);
    logFilter("bookmarks", "back with bookmarks data", response);
    //if (response && (response !== undefined) && response.rc === 'OK') {
    if (response && response !== undefined) {
      logFilter("bookmarks", "back with bookmarks data good?", response);
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const persistedAppDataSlice = createSlice({
  name: "persistedAppData",
  initialState: {
    //bookmarks: []
  },
  reducers: {
    handleUserInfo: (state, action) => {
      logFilter("persistedAppData", "handleUserInfo", action.payload);
      state.userinfo = action.payload;
    },
    handleLookupData: (state, action) => {
      logFilter("persistedAppData", "handleLookupData", action.payload);
      state.lookupdata = action.payload;

      const { buildings, units } = action.payload;

      const buildingsById = {};
      buildings.forEach((it) => {
        buildingsById[it.id] = it;
      });
      state.lookupdata.buildingsById = buildingsById;
      state.lookupdata.unitsById = units;
    },
    handleBookmarks: (state, action) => {
      logFilter("persistedAppData", "handleBookmarks", action.payload);
      state.bookmarks = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveUserOptions.fulfilled, (state, action) => {
        logFilter("UserOptions", "saveUserOption.fulfilled");
        if (action.payload) {
          logFilter("UserOptions", action.payload);
          if (action.payload.response.rc === "OK") {
            logFilter("UserOptions", "ok, let's update state");
            state.userinfo = {
              ...state.userinfo,
              options: action.payload.response.payload.result,
            };
          } else {
            logFilter(
              "UserOptions",
              "setting lastError",
              action.payload.response,
            );
            state.lastError = action.payload.response.context;
          }
        }
      })
      .addCase(getBookmarksForUser.fulfilled, (state, action) => {
        logFilter("bookmarks", "getBookmarksForUser.fulfilled", action);
        if (action.payload) {
          logFilter("bookmarks", "storing payload");
          if (action.payload.response.rc === "OK") {
            state.bookmarks = action.payload.response.payload.data;
          } else {
            logFilter(
              "bookmarks",
              "setting lastError",
              action.payload.response,
            );
            state.lastError = action.payload.response.context;
          }
        } else {
          logFilter("bookmarks", "NO bookmarks list payload to store");
        }
      });
    // .addCase(saveOneBookmarkForUser.fulfilled, (state, action) => {
    //   logFilter('bookmarks', 'saveOneBookmarkForUser.fulfilled', action)
    //   if (action.payload) {
    //     logFilter('bookmarks', 'storing payload')
    //     if (action.payload.response.rc === 'OK') {
    //       state.bookmarks = action.payload.response.payload.data
    //     } else {
    //       logFilter('bookmarks', 'setting lastError', action.payload.response)
    //       state.lastError = action.payload.response.context
    //     }
    //   } else {
    //     logFilter('bookmarks', 'NO bookmarks list payload to store')
    //   }
    // })

    // .addCase(updateBookmarked.fulfilled, (state, action) => {
    //   let objectToUpdate
    //   logFilter('store', 'updateBookmarked addCase')
    //   // ** find & update object
    //   state.suggestions.find(item => {
    //     if (item.id === action.payload) {
    //       item.isBookmarked = !item.isBookmarked
    //       objectToUpdate = item
    //     }
    //   })

    //   // ** Get index to add or remove bookmark from array
    //   const bookmarkIndex = state.bookmarks.findIndex(x => x.id === action.payload)

    //   if (bookmarkIndex === -1) {
    //     state.bookmarks.push(objectToUpdate)
    //   } else {
    //     state.bookmarks.splice(bookmarkIndex, 1)
    //   }
    // })
  },
});

export const {
  handleUserInfo, // called from login result when successful
  handleLookupData, // called from login result when successful
  handleBookmarks, // called from login result when successful
} = persistedAppDataSlice.actions;

export default persistedAppDataSlice.reducer;
